import { useParams } from 'react-router-dom';

import { Box } from '@mui/material';

import PrimaryLayout from '../../components/layout/PrimaryLayout';
import { axiosGiteaInstance } from '../../services/api-client';

const CurrentBlockRunnerLogs = () => {
  const { block_type, runner_id, commit_id } = useParams();
  console.log("---------------->", block_type, runner_id, commit_id);

  const fetchLogs = async () => {
    try {
      const response = await axiosGiteaInstance.post(
        `/Centurion/${block_type}/actions/runs/${runner_id}/jobs/0`,
        {
          logCursors: [
            { step: 0, cursor: null, expanded: true },
            { step: 1, cursor: null, expanded: false },
            { step: 2, cursor: null, expanded: false },
            { step: 3, cursor: null, expanded: false },
            { step: 4, cursor: null, expanded: false },
            { step: 5, cursor: null, expanded: false }
          ]
        }
      );
  
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    }
  };

  fetchLogs();

  return (
    <PrimaryLayout>
        <Box>
            Current Block Runner Logs
        </Box>
    </PrimaryLayout>
  )
}

export default CurrentBlockRunnerLogs